// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ReferralDiagnosisResponse } from './referral-diagnosis-response';

// @ts-ignore
import { ReferralProviderResponse } from './referral-provider-response';

// @ts-ignore
import { ReferralSnomedCodeResponse } from './referral-snomed-code-response';

/** See com.rev360.pms.api.controller.patient.referral.ReferralResponse */
/* istanbul ignore next */
@GandalfModel
export class ReferralResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	active!: boolean;

	@GandalfProperty({ designType: Boolean })
	appointmentCreated!: boolean | null;

	@GandalfProperty({ designType: Date })
	appointmentDate!: Date | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: ReferralDiagnosisResponse })
	diagnosis!: ReferralDiagnosisResponse | null;

	@GandalfProperty({ designType: Boolean })
	documentsProvided!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	documentsSentElectronically!: boolean | null;

	@GandalfProperty({ designType: Number })
	personId!: number;

	@GandalfProperty({ designType: String })
	reason!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	referralDate!: Date;

	@GandalfProperty({ designType: Number })
	referralId!: number;

	@GandalfProperty({ designType: ReferralSnomedCodeResponse })
	referralType!: ReferralSnomedCodeResponse | null;

	@GandalfProperty({ designType: ReferralProviderResponse })
	referredBy!: ReferralProviderResponse | null;

	@GandalfProperty({ designType: Boolean })
	referredByEmployeeHasDirectMessaging!: boolean | null;

	@GandalfProperty({ designType: ReferralProviderResponse })
	referredTo!: ReferralProviderResponse | null;

	@GandalfProperty({ designType: String })
	responseComments!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	responseDate!: Date | null;

	@GandalfProperty({ designType: Boolean })
	responseReportReceived!: boolean | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	responseRequestDate!: Date | null;

	@GandalfProperty({ designType: String })
	toBeSeen!: string | null;

}
